export default "__VITE_ASSET__bElqMLOQ__"